import { logError } from './logging';
import { dataUrlToFile } from './starMapUtils';

/**
 * Creates a blank white canvas as a File object.
 *
 * @param {number} width - Canvas width in pixels (default: 1000)
 * @param {number} aspectRatio - Width to height ratio (default: 16/9)
 * @returns {File} The blank canvas as a JPG File
 */
export function createBlankCanvasFile(width = 1000, aspectRatio = 16 / 9) {
  const height = Math.round(width / aspectRatio);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');

  if (!ctx) {
    logError({
      label: 'createBlankCanvasFile',
      error: new Error('Could not get canvas context'),
      message: 'Could not get canvas context'
    });

    return null;
  }

  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, width, height);

  const dataUrl = canvas.toDataURL('image/jpeg', 0.9);
  return dataUrlToFile(dataUrl, 'doodle-canvas.jpg');
}
